import { RootState } from '~/store/store';

export const getRelativeGetStore = <T>(callback: (rootState: RootState) => T) => {
  return (store: RootState) => {
    return callback(store);
  };
};
